const TopSongs = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.50049 15L2.50049 10C2.50049 8.01088 3.29066 6.10322 4.69719 4.6967C6.10371 3.29018 8.01136 2.5 10.0005 2.5C11.9896 2.5 13.8973 3.29018 15.3038 4.6967C16.7103 6.10322 17.5005 8.01088 17.5005 10V15"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5005 15.8333C17.5005 16.2753 17.3249 16.6992 17.0123 17.0118C16.6998 17.3244 16.2758 17.5 15.8338 17.5H15.0005C14.5585 17.5 14.1345 17.3244 13.822 17.0118C13.5094 16.6992 13.3338 16.2753 13.3338 15.8333V13.3333C13.3338 12.8913 13.5094 12.4673 13.822 12.1548C14.1345 11.8422 14.5585 11.6666 15.0005 11.6666H17.5005V15.8333ZM2.50049 15.8333C2.50049 16.2753 2.67608 16.6992 2.98864 17.0118C3.3012 17.3244 3.72513 17.5 4.16715 17.5H5.00049C5.44252 17.5 5.86644 17.3244 6.179 17.0118C6.49156 16.6992 6.66715 16.2753 6.66715 15.8333L6.66715 13.3333C6.66715 12.8913 6.49156 12.4673 6.179 12.1548C5.86644 11.8422 5.44252 11.6666 5.00049 11.6666H2.50049L2.50049 15.8333Z"
      stroke="#444444"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TopSongs;
